import React from "react";
import { PageHeader } from "@/components/common/UI";
import { openPdf } from "@/lib/api";
import { toast } from "sonner";
import { FilePdf, Books, ClipboardText, Bed } from "@phosphor-icons/react";

const reports = [
  { name: "admission-register", title: "Admission Register", desc: "All admissions in chronological order — NABH-aligned for IPD register inspections.", icon: Books },
  { name: "discharge-register", title: "Discharge Register", desc: "All discharged patients with admit/discharge dates and consultants.", icon: ClipboardText },
  { name: "daily-census", title: "Daily Census", desc: "Currently admitted in-patients by ward & bed.", icon: Bed },
];

export default function ReportsPage() {
  const open = (name) =>
    openPdf(`/pdf/report/${name}`, `${name}.pdf`).catch((e) => toast.error(e.message || "PDF failed"));

  return (
    <div data-testid="reports-page">
      <PageHeader eyebrow="NABH" title="Hospital Reports"
        subtitle="Generate printable, NABH-aligned registers and operational reports as one-click PDFs." />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {reports.map((r) => {
          const Icon = r.icon;
          return (
            <div key={r.name} className="hms-card p-5 flex flex-col gap-3" data-testid={`report-card-${r.name}`}>
              <div className="flex items-start gap-3">
                <div className="h-10 w-10 grid place-items-center bg-[var(--hms-paper)] border border-[var(--hms-border-2)] rounded-sm">
                  <Icon size={20} weight="bold" className="text-[var(--hms-ink)]" />
                </div>
                <div>
                  <div className="font-heading font-bold">{r.title}</div>
                  <div className="text-sm text-[var(--hms-text-2)]">{r.desc}</div>
                </div>
              </div>
              <div>
                <button onClick={() => open(r.name)}
                   className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold uppercase tracking-wider rounded-sm border border-[var(--hms-border-2)] hover:shadow-[3px_3px_0_var(--hms-ink)] hover:-translate-x-[1px] hover:-translate-y-[1px] transition-all bg-white"
                   data-testid={`report-pdf-${r.name}`}>
                  <FilePdf size={14} weight="bold" /> Generate PDF
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
